import React from 'react';
import * as consts from 'config/consts';

export type Side = typeof consts.Side[keyof typeof consts.Side];

export const sideToColors = (
  side: Side
): { backgroundColor: string; foregroundColor: string } => {
  const defaultList = {
    backgroundColor: '',
    foregroundColor: '',
  };

  switch (side) {
    case consts.Side.売:
      return {
        backgroundColor: '#429B45',
        foregroundColor: '#FFFFFF',
      };
    case consts.Side.買:
      return {
        backgroundColor: '#F57C00',
        foregroundColor: '#FFFFFF',
      };
    case consts.Side.不明:
      return {
        backgroundColor: '#8E9DB2',
        foregroundColor: '#FFFFFF',
      };
    default:
      return defaultList;
  }
};

export const sideToString = (side: Side): string => {
  const defaultValue = '';

  switch (side) {
    case consts.Side.売:
      return '売り';
    case consts.Side.買:
      return '買い';
    case consts.Side.不明:
      return 'その他';
    default:
      return defaultValue;
  }
};

export const SideLabel = ({ side }: { side: Side }) => {
  const { backgroundColor, foregroundColor } = sideToColors(side);
  const str = sideToString(side);

  return (
    <>
      <div
        style={{ color: foregroundColor, backgroundColor }}
        className={`${
          side === consts.Side.不明 ? 'w-15' : 'w-12'
        } h-8.5 rounded px-2 py-1 text-sm justify-center items-center flex font-bold`}>
        {str}
      </div>
    </>
  );
};
